import React, { useEffect, useState } from 'react';

import { Demanda, getDemandasDemandante, TipoDemanda } from '@app/api/demanda';
import { currencyFormat } from '@app/helpers/numbers';
import { Button, Table, Widget } from '@digital/ui';
import { Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';

const DemandasAndamento = () => {
  const [dados, setDados] = useState<Demanda[]>([]);
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    getDemandasDemandante().then(data => {
      if (data) {
        setDados(data);
      }
    });
  }, [update]);

  const columns: ColumnProps<any>[] = [
    {
      title: 'Código',
      dataIndex: 'identificadorTexto',
    },
    {
      title: 'Tipo',
      dataIndex: 'tipo',
      render: (text, record) => (record.tipo ? TipoDemanda[record.tipo] : ''),
    },
    {
      title: 'Tipo de Serviço',
      dataIndex: 'tipoServico',
    },
    {
      title: 'Valor Final',
      dataIndex: 'expectativaValorFinal',
      render: (text, record) => currencyFormat(record.expectativaValorFinal),
    },
    {
      title: 'RC',
      dataIndex: 'rc',
    },
    {
      title: 'OC',
      dataIndex: 'oc',
    },
    {
      title: 'Status',
      dataIndex: 'statusDemandaNome',
    },
    {
      title: 'Responsável Gpc',
      dataIndex: 'responsavelGpcNome',
    },
    {
      title: 'Comprador',
      dataIndex: 'compradorNome',
    },
    {
      title: 'Gov. Aprovação',
      dataIndex: 'govAprovacao',
    },
    {
      title: 'DDI',
      dataIndex: 'ddi',
    },
    {
      title: 'Ações',
      render: (index, record) => (
        <Tooltip title="Ir para Demanda">
          <Button
            type="link"
            icon="arrows-circled_up_right_2"
            name="irparaBm"
            onClick={() => {
              const urlBase = window.location.origin;
              window.open(urlBase + `/demanda/questionario/${record.id}`);
            }}
            href="#"
          />
        </Tooltip>
      ),
      width: '1%',
    },
  ];

  return (
    <Widget
      title="Em Andamento"
      actions={[
        <Button
          id="mrn-btn-criar-nova-demanda"
          title="criar nova demanda"
          type="primary"
          onClick={() => {
            const urlBase = window.location.origin;
            window.open(urlBase + `/demandas/new`);
          }}
        />,
      ]}>
      <Table
        id="mrn-table-demandas-em-andamento"
        columns={columns} dataSource={dados} />
    </Widget>
  );
};
export default DemandasAndamento;
